export default {
    setTotal(state : any){
        const total = state.notif.reduce((accumulator : any, item : any) => accumulator + item.total, 0);
        state.total = total;
    },
    
    setItemNotif(state: any, newData: any){
        state.notif[newData.index].total = newData.value;
    },

    addItem(state: any, newData: any){
        state.notif.push(newData);
    },
};
